module.exports = __webpack_public_path__ + "img/geo-alt.svg";